import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
export function ServiceAreas() {
  const areas = [{
    county: 'St. Clair County',
    type: 'Primary',
    cities: ['Port Huron', 'Marysville', 'St. Clair', 'Marine City', 'New Baltimore', 'Algonac', 'Ira Township', 'China Township', 'Casco Township']
  }, {
    county: 'Macomb County',
    type: 'Secondary',
    cities: ['Harrison Township', 'Clinton Township', 'Chesterfield', 'Macomb Township', 'Sterling Heights', 'Warren', 'Roseville', 'Utica', 'St. Clair Shores']
  }, {
    county: 'Oakland County',
    type: 'Tertiary',
    cities: ['Troy', 'Rochester Hills', 'Auburn Hills', 'Pontiac', 'Clarkston', 'Lake Orion', 'Oxford']
  }];
  return <section className="py-20 bg-white" data-id="element-412">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-413">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-414">
          <MapPin size={40} className="text-brand-blue mx-auto mb-4" data-id="element-415" />
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-brand-gray-dark mb-4" data-id="element-416">
            Proudly Serving Southeast Michigan
          </h2>
          <div className="w-20 h-1 bg-brand-blue mx-auto mb-6 rounded-full" data-id="element-417"></div>
          <p className="font-body text-brand-gray text-lg" data-id="element-418">
            Based in Harrison Township, we provide top-tier exterior services to
            homeowners and businesses across three counties.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-419">
          {areas.map((area, index) => <div key={index} className="bg-gray-50 rounded-xl p-8 border border-gray-100" data-id="element-420">
              <div className="flex items-center justify-between mb-6 border-b border-gray-200 pb-4" data-id="element-421">
                <h3 className="font-heading font-bold text-xl text-brand-blue" data-id="element-422">
                  {area.county}
                </h3>
                <span className="text-xs font-body font-semibold bg-white px-2 py-1 rounded text-brand-gray shadow-sm" data-id="element-423">
                  {area.type}
                </span>
              </div>
              <ul className="space-y-3" data-id="element-424">
                {area.cities.map((city, cityIndex) => <li key={cityIndex} data-id="element-425">
                    <Link to={`/area/${city.toLowerCase().replace(/\s+/g, '-')}`} className="font-body text-brand-gray hover:text-brand-blue transition-colors flex items-center before:content-[''] before:w-1.5 before:h-1.5 before:bg-brand-blue before:rounded-full before:mr-3" data-id="element-426">
                      {city}
                    </Link>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}